import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { ContenuPromo } from '@components/contenu-promo/models';
import { ButtonComponent } from '@shared/components/button';
import { ImageComponent } from '@shared/components/image';
import { TitleComponent } from '@shared/components/title';
import { HandleHtmlLinksDirective } from '@shared/directives';
import { PromotionStore } from '@stores';

@Component({
  selector: 'app-contenu-promo',
  templateUrl: './contenu-promo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageComponent, TitleComponent, ButtonComponent, HandleHtmlLinksDirective],
})
export class ContenuPromoComponent extends AbstractDynamicComponent<ContenuPromo> {
  protected readonly contenuPromo = inject(PromotionStore).select('contenuPromo');
}
